import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as settingsService from '_services/settings'

export const GET_SETTINGS = defineAction('GET_SETTINGS')
export const UPDATE_SETTINGS = defineAction('UPDATE_SETTINGS')

export const getSettings = () => (dispatch, getState) =>
  dispatch({
    type: GET_SETTINGS,
    payload: settingsService.getSettings(getState().user.get('token')),
  })

export const updateSettings = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_SETTINGS,
    payload: settingsService
      .updateSettings(getState().user.get('token'))(payload)
      .then(() => payload),
  })



// WEBPACK FOOTER //
// ./src/modules/settings/actions.js